import React from 'react';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import DropdownMenu, { DropdownItemGroup, DropdownItem } from '@atlaskit/dropdown-menu';
import { Box, xcss } from '@atlaskit/primitives';
import { Currency, ALL_CURRENCY_FILTER_TYPE, FILTER_TYPE_ALL } from './multi-currency-utils';
import './limit-currency-dropdown.scss';
import className from 'classnames';

const contentStyles = xcss({
  minWidth: '190px',
});

export type LimitCurrencyDropdownProps = {
  currency: string;
  setCurrency: React.Dispatch<React.SetStateAction<string>>;
  label?: string;
  showLabel?: boolean;
  isDesignIteration1Enabled?: boolean;
  isLightTheme?: boolean;
  isFilter?: boolean;
  showAllCurrency?: boolean;
  shouldPrependCurrencyText?: boolean;
};

export const LimitCurrencyDropdown = ({
  currency,
  setCurrency,
  label,
  showLabel,
  isDesignIteration1Enabled,
  isLightTheme,
  isFilter,
  showAllCurrency,
  shouldPrependCurrencyText, // shouldPrependCurrencyText works with isDesignIteration1Enabled
}: LimitCurrencyDropdownProps) => {
  const defaultCurrency = {
    label: FILTER_TYPE_ALL,
    value: '',
  };

  let currencyOptions = Object.keys(Currency).map((currency) => ({
    label: currency,
    value: currency as string,
  }));

  if (showAllCurrency) {
    currencyOptions = [defaultCurrency, ...currencyOptions];
  }

  const prependText = shouldPrependCurrencyText ? ALL_CURRENCY_FILTER_TYPE + ': ' : '';
  let triggerText;

  if (isDesignIteration1Enabled) {
    triggerText = showAllCurrency && currency === '' ? prependText + 'All' : prependText + currency;
  } else {
    triggerText = showAllCurrency && currency === '' ? ALL_CURRENCY_FILTER_TYPE : currency;
  }

  return (
    <div
      className={className('currency-dropdown-wrapper', {
        'currency-dropdown-wrapper-V1': !isDesignIteration1Enabled,
        'is-dark': !isLightTheme && !isFilter,
        'is-filter': isFilter,
      })}
      data-testid="currency-dropdown"
    >
      {showLabel && <label className="label">{label}</label>}
      <DropdownMenu
        triggerType="button"
        trigger={triggerText}
        triggerButtonProps={{
          appearance: (isDesignIteration1Enabled && !isLightTheme) || isFilter ? 'default' : 'subtle',
          role: 'menu',
          iconAfter: <ChevronDownIcon label="More" />,
          className: className('dropdown-button', {
            'ppc-dark-btn': !isLightTheme,
          }),
        }}
      >
        <DropdownItemGroup>
          {currencyOptions.map((each) => (
            <DropdownItem key={each.value} id={each.value} onClick={() => setCurrency(each.value)}>
              {isFilter ? <Box xcss={contentStyles}>{each.label}</Box> : each.label}
            </DropdownItem>
          ))}
        </DropdownItemGroup>
      </DropdownMenu>
    </div>
  );
};
